import { useQueryClient } from '@tanstack/react-query';
import { DashboardJobsType } from '../dashboardJobsApi';
import { IDashboardJobsInfo } from '../dashboardJobsTypes';

export const useDashboardJobInfo = (jobType?: DashboardJobsType) => {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(['dashboard-jobs-info', jobType ?? DashboardJobsType.ALL]);

  return data as IDashboardJobsInfo | undefined;
};
